"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EConnaissanceExperienceGroupsTrads = void 0;
exports.EConnaissanceExperienceGroupsTrads = {
    dejaSouscritScpi: "Avez-vous déjà souscrit des SCPI",
    nbSouscriptionsScpi: "Nombre de souscriptions au cours des 12 derniers mois",
    datePremiereSouscription: "Date approximative de la première souscription",
    dateDerniereSouscription: "Date approximative de la dernière souscription",
    experienceProfessionnelle: "Avez-vous une expérience professionnelle d'au moins un an vous permettant d'acquérir une bonne connaissance des marchés financiers et/ou immobiliers ? ",
    supportPlacement: "Indiquez les supports de placement",
    modeGestionUtilise: "Mode de gestion auquel vous avez recours",
    nbOperationsDerniersMois: "Nombre d'opérations réalisées sans conseiller au cours des 12 derniers mois",
    risqueRendementAccepter: "Quel degré de risque/rendement êtes-vous prêt à accepter ?",
    connaissancesMarcheFinancierProduitsEpargne: "Comment qualifierez-vous votre niveau de connaissances du marché financier et des produits d'épargne?",
    combienTempsRealisezInvestissements: "Depuis combien de temps réalisez-vous des investissements",
    dejaPertePlacement: "Avez-vous déjà été en situation de perte sur vos placements financiers ?",
    reactionChuteBrusqueValeurInvestissement: "Quelle serait votre réaction si la valeur de vos investissements venait à chuter brusquement ?",
    connaissancesMarcheImmobilier: "Comment qualifierez-vous votre niveau de connaissances du marché et des produits immobiliers ? ",
    scpiOpciNombreSouscriptions: "Nombre de souscriptions de parts de SCPI",
    dejaSouscritScpiNamePierval: "Précisez le nom des SCPI",
    dejaSouscritScpiPartPierval: "Quelle part représentent les SCPI dans votre patrimoine ?",
};
